import { Spinner } from "react-bootstrap";

export default function Loader() {
    return (
        <div className="d-flex align-items-center justify-content-center py-5" style={{ minHeight: "300px" }}>
            <div className="text-center">
                <Spinner animation="border" variant="primary" role="status" style={{ width: '36px', height: '36px' }} />
                <div className="text-muted mt-3 text-small">Cargando...</div>
            </div>
        </div>
    )
}